module.exports = __webpack_public_path__ + "img/1281767970.14fcfc41.jpg";